export enum InputType {
  Default = 'text',
  Password = 'password',
  Checkbox = 'checkbox',
  Number = 'number'
}
